module.exports = __webpack_public_path__ + "img/2-3.67acef66.svg";